import React from 'react';
import { useMediaQuery } from 'react-responsive';
import ContactContent from './ContactContent';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const MobileResponsive = ({
  history,
  fields,
  contactSubmit,
  handleChange,
  submitted,
}) => (
  <Mobile>
    <ContactContent
      history={history}
      fields={fields}
      contactSubmit={contactSubmit}
      handleChange={handleChange}
      submitted={submitted}
    />
  </Mobile>
);

export default MobileResponsive;
